import {FieldValues, Path, UseFormSetError} from 'react-hook-form';

/**
 * Универсальная обработка ошибок от сервера для форм.
 * @param err - ошибка (обычно AxiosError)
 * @param setError - функция setError из useForm
 */
export function processFormServerError<T extends FieldValues>(
    err: any,
    setError: UseFormSetError<T>,
) {
    const fieldErrors = err?.response?.data as { [key: string]: string };
    let expectedError = false;

    if (fieldErrors) {
        if (fieldErrors?.status) {
            expectedError = false
        } else {
            Object.entries(fieldErrors).forEach(([key, message]) => {
                let field = key.split('.').pop() as Path<T>
                if (field) {
                    setError(field, {type: 'server', message})
                    expectedError = true
                }
            });
        }

    }

    if (!expectedError) setError('root', {type: 'server', message: 'Ошибка отправки формы'});
}